import { Heart, Users, Shield } from "lucide-react";

const Features = () => {
  const features = [
    {
      icon: <Heart className="h-12 w-12 text-primary" />,
      title: "Meaningful Connections",
      description:
        "Our advanced matching algorithm helps you find compatible partners based on shared interests and values.",
    },
    {
      icon: <Users className="h-12 w-12 text-primary" />,
      title: "Active Community",
      description:
        "Join local events and groups to meet other seniors in your area and make new friends.",
    },
    {
      icon: <Shield className="h-12 w-12 text-primary" />,
      title: "Safe and Secure",
      description:
        "Your privacy and safety are our top priorities. Enjoy peace of mind with our verified profiles and secure messaging.",
    },
  ];

  return (
    <section id="features" className="py-20 px-4 md:px-6 lg:px-8 bg-white">
      <div className="container mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
          Why Choose Aura?
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="mb-4 flex justify-center">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
